// extracted by mini-css-extract-plugin
export default {"ellipsis":"formStyles-module__ellipsis__F5iNv","flashing":"formStyles-module__flashing__Sn5eT","flashAnimation":"formStyles-module__flashAnimation__9u-Hf"};